import Card from "@pathwright/ui/src/components/card/Card"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import MentorGroups from "./MentorGroups"

const MentorGroupsCard = ({ card }) => {
  const { t } = useTranslate()

  return (
    <Card className="MentorGroupsCard" card={card} title={t("Manage Groups")}>
      <MentorGroups parentId={null} />
    </Card>
  )
}

MentorGroupsCard.displayName = "MentorGroupsCard"

export default MentorGroupsCard
